// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"551":"5643f081","842":"017b1d8e"}[chunkId] + ".chunk.css";
};